"use client";
import { Globe2Icon, Layers3Icon, Settings2Icon, SmartphoneIcon } from "lucide-react";

export function Features() {
  return (
    <section id="features" className="py-12 md:py-20 relative z-10">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="mb-12">
          <h2 className="text-4xl md:text-6xl font-black text-white tracking-tighter mb-6 max-w-2xl">
            Projetado para a <span className="text-white/40">eficiência extrema.</span>
          </h2>
          <p className="text-xl text-white/50 max-w-xl">
            Cada detalhe foi pensado para reduzir o atrito. Seu cliente agenda rápido, você gerencia sem esforço.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          
          {/* Feature 1 */}
          <div className="group relative overflow-hidden rounded-3xl bg-[#0a0a0a]/80 backdrop-blur-md border border-white/5 p-8 md:p-10 hover:border-white/20 transition-colors">
            <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
               <Layers3Icon className="size-32 text-primary" />
            </div>
            <div className="relative z-10 flex flex-col h-full justify-between gap-12">
               <div className="size-14 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center text-white mb-4">
                 <Globe2Icon className="size-6" />
               </div>
               <div>
                  <h3 className="text-2xl font-bold text-white mb-3 tracking-tight">Sua marca online</h3>
                  <p className="text-white/60 leading-relaxed">
                    Subdomínio próprio gratuito, logo e cores da sua marca. 
                    Uma página profissional que converte visitantes em clientes fiéis.
                  </p>
               </div>
            </div>
          </div>

          {/* Feature 2 */}
          <div className="group relative overflow-hidden rounded-3xl bg-[#0a0a0a]/80 backdrop-blur-md border border-white/5 p-8 md:p-10 hover:border-white/20 transition-colors">
            <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity">
               <SmartphoneIcon className="size-32 text-primary" />
            </div>
            <div className="relative z-10 flex flex-col h-full justify-between gap-12">
               <div className="size-14 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center text-white mb-4">
                 <SmartphoneIcon className="size-6" />
               </div>
               <div>
                  <h3 className="text-2xl font-bold text-white mb-3 tracking-tight">App sem download</h3>
                  <p className="text-white/60 leading-relaxed">
                    Com tecnologia PWA, seus clientes salvam sua página na tela inicial do celular. 
                    Acesso direto, rápido e sem ocupar espaço no aparelho.
                  </p>
               </div>
            </div>
          </div>

          {/* Feature 3 - Full Width */}
          <div className="md:col-span-2 group relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#111] to-[#050505] border border-white/5 p-8 md:p-12 hover:border-white/20 transition-colors">
            <div className="absolute inset-0 bg-[url('/noise.png')] opacity-10 mix-blend-overlay pointer-events-none" />
            <div className="relative z-10 flex flex-col md:flex-row items-center gap-12">
               <div className="flex-1 space-y-6">
                  <div className="size-14 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center text-white">
                    <Settings2Icon className="size-6" />
                  </div>
                  <h3 className="text-3xl md:text-4xl font-bold text-white tracking-tight">Gestão Absoluta</h3>
                  <p className="text-lg text-white/60 leading-relaxed max-w-lg">
                    Controle de horários, folgas, serviços e histórico de clientes. 
                    Dashboard administrativo completo para você ter os números do seu negócio na palma da mão.
                  </p>
               </div>
               <div className="w-full md:w-1/2 rounded-2xl bg-black/50 border border-white/10 p-6 shadow-2xl relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-primary/30 blur-[50px]" />
                  <div className="space-y-4">
                     {/* Fake Dashboard Rows */}
                     <div className="h-2 w-20 bg-white/20 rounded-full mb-6" />
                     {[1,2,3].map(i => (
                       <div key={i} className="flex items-center justify-between p-4 rounded-xl bg-white/5 border border-white/5">
                          <div className="flex items-center gap-4">
                            <div className="size-10 rounded-full bg-white/10" />
                            <div>
                               <div className="h-3 w-24 bg-white/40 rounded-full mb-2" />
                               <div className="h-2 w-16 bg-white/20 rounded-full" />
                            </div>
                          </div>
                          <div className="h-6 w-16 bg-green-500/20 rounded-lg" />
                       </div>
                     ))}
                  </div>
               </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
